export class Websocket_message_info_sender {
    role: string;
    persona_id: number;
}
export class Websocket_message_info {
    message_type: string;
    object_id: number;
    sender: Websocket_message_info_sender;
}

export class Websocket_message_action {
    action_type: string;
}

export class Websocket_message {
    info: Websocket_message_info;
    action: Websocket_message_action;
    data: any;
}